import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Articles from './pages/Articles';
import Templates from './pages/Templates';
import TemplateEditor from './pages/TemplateEditor';
import Campaigns from './pages/Campaigns';
import MQLs from './pages/MQLs';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Scraper from './pages/Scraper';
import Domains from './pages/Domains';
import NurtureDashboard from './pages/NurtureDashboard';
import AIDraftReview from './pages/AIDraftReview';
import NurtureAnalytics from './pages/NurtureAnalytics';
import Unsubscribe from './pages/Unsubscribe';
import ContactDiscovery from './pages/ContactDiscovery';
import ContactEnrichment from './pages/ContactEnrichment';
import BudgetDashboard from './pages/BudgetDashboard';
import Dialer from './pages/Dialer';
import Layout from './components/Layout';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="leads" element={<Leads />} />
          <Route path="articles" element={<Articles />} />
          <Route path="templates" element={<Templates />} />
          <Route path="templates/editor/:id?" element={<TemplateEditor />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="mqls" element={<MQLs />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="settings" element={<Settings />} />
          <Route path="scraper" element={<Scraper />} />
          <Route path="domains" element={<Domains />} />
          <Route path="nurture" element={<NurtureDashboard />} />
          <Route path="nurture-analytics" element={<NurtureAnalytics />} />
          <Route path="ai-drafts" element={<AIDraftReview />} />
          <Route path="contact-discovery" element={<ContactDiscovery />} />
          <Route path="contact-enrichment" element={<ContactEnrichment />} />
          <Route path="budget/:discoveryId" element={<BudgetDashboard />} />
          <Route path="dialer" element={<Dialer />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;

